import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex-grow bg-neutral-100" }
const _hoisted_2 = { class: "container mx-auto max-w-6xl" }
const _hoisted_3 = { class: "text-3xl mt-8 ml-6" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "inline-block mt-1 ml-6 text-gray-600 font-medium text-sm hover:text-indigo-600",
  href: "https://usersearch.org/landing/index.html",
  rel: "noopener"
}
const _hoisted_7 = { class: "sticky z-10 mt-6 top-0 bg-neutral-100" }
const _hoisted_8 = {
  class: "pl-6 flex gap-7 items-center md:gap-8",
  "aria-label": "Tabs"
}
const _hoisted_9 = { class: "py-1" }
const _hoisted_10 = {
  href: "https://controld.com/?cid=nslookup",
  target: "_blank",
  rel: "noopener nereferrer"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "inline sm:hidden" }, "Other", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:inline" }, "Local DNS", -1)
const _hoisted_13 = { class: "py-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "block px-4 mt-2 text-sm font-semibold text-gray-500 sm:hidden" }, "Global", -1)
const _hoisted_15 = { class: "block px-4 mt-2 text-sm font-semibold text-gray-500" }
const _hoisted_16 = { class: "grow" }
const _hoisted_17 = { class: "bg-white shadow p-6 pb-10 rounded-t" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "mb-2" }
const _hoisted_21 = { class: "mt-2" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { key: 3 }
const _hoisted_26 = { key: 4 }
const _hoisted_27 = { key: 5 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://controld.com/free-dns?cid=nslookup",
  class: "text-blue-600 hover:text-blue-800 hover:underline",
  target: "_blank",
  rel: "noopener noreferrer"
}, "Configure this server on your device.", -1)
const _hoisted_29 = { key: 3 }
const _hoisted_30 = { class: "flex gap-6" }
const _hoisted_31 = {
  key: 0,
  class: "shrink w-full lg:max-w-2xl"
}
const _hoisted_32 = {
  key: 1,
  class: "shrink w-full lg:max-w-2xl"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-8 mb-2 font-semibold text-2xl" }, "A records", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-8 mb-2 font-semibold text-2xl" }, "AAAA records", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-8 mb-2 font-semibold text-2xl" }, "CNAME record", -1)
const _hoisted_36 = {
  key: 2,
  class: "grow w-[330px] mt-10 hidden lg:block"
}
const _hoisted_37 = {
  key: 4,
  "aria-hidden": "true",
  class: "mb-8"
}
const _hoisted_38 = { key: 5 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-8 mb-2 font-semibold text-2xl" }, "TXT records", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-8 mb-2 font-semibold text-2xl" }, "NS records", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-8 mb-2 font-semibold text-2xl" }, "MX records", -1)
const _hoisted_42 = {
  key: 6,
  "aria-hidden": "true",
  class: "mt-6 mb-8"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-8 mb-4 font-semibold text-2xl inline-block" }, "Other records", -1)
const _hoisted_44 = { class: "relative" }
const _hoisted_45 = {
  key: 8,
  "aria-hidden": "true",
  class: "mt-6 mb-8"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-8 mb-2 font-semibold text-2xl" }, "Look up DNS records for another domain name", -1)
const _hoisted_47 = { class: "flex flex-col lg:flex-row" }
const _hoisted_48 = { class: "shrink max-w-xl" }
const _hoisted_49 = {
  class: "mt-3 w-[500px] max-w-full sm:px-6 lg:mt-0",
  autocomplete: "off"
}

import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios, { Canceler } from 'axios';
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxLabel,
  ComboboxOption,
  ComboboxOptions,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from '@headlessui/vue';
import {
  CheckIcon,
  ChevronUpDownIcon,
  ChevronDownIcon,
  ArrowTopRightOnSquareIcon,
} from '@heroicons/vue/20/solid';
import { Cog6ToothIcon } from '@heroicons/vue/24/outline';
import HeaderComponent from '@/components/layout/HeaderComponent.vue';
import FooterComponent from '@/components/layout/FooterComponent.vue';
import DnsRecords from '@/components/records/DnsRecords.vue';
import IpDnsRecords from '@/components/records/IpDnsRecords.vue';
import SoaRecords from '@/components/records/SoaRecords.vue';
import TxtRecords from '@/components/records/TxtRecords.vue';
import MxRecords from '@/components/records/MxRecords.vue';
import ToggleRawOutput from '@/components/ToggleRawOutput.vue';
import NsRecords from '@/components/records/NsRecords.vue';
import MetaTags from '@/components/MetaTags.vue';
import CaaRecords from '@/components/records/CaaRecords.vue';
import PtrRecords from '@/components/records/PtrRecords.vue';
import SrvRecords from '@/components/records/SrvRecords.vue';
import TlsaRecords from '@/components/records/TlsaRecords.vue';
import { domainNameToDisplayName, domainNameToUrlPath, urlPathToDomainName } from '@/common/domainName';
import SkeletonComponent from '@/components/micro/SkeletonComponent.vue';
import DomainSearch from '@/components/DomainSearch.vue';
import { ApiErrorType, toErrorType } from '@/model/ApiErrorAlert';
import ApiErrorAlert from '@/components/ApiErrorAlert.vue';
import { dnsServers } from '@/common/dnsServers';
import {
  GetRecordsResponse, PopularRecords, QueryResult, emptyPopularRecords, emptyQueryResult,
} from '@/model/Api';
import AdUnit from '@/components/ads/AdUnit.vue';
import { DnsRecordsOther, DnsRecordsSidebar, DnsRecordsTxt } from '@/common/adSlots';
import { showUsersearchAd } from '@/common/dateTime';


export default /*#__PURE__*/_defineComponent({
  __name: 'DnsRecordsResults',
  props: {
  routerDomain: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;


const route = useRoute();
const router = useRouter();

const tabs = [
  { name: 'cloudflare', display: 'Cloudflare' },
  { name: 'google', display: 'Google DNS' },
  { name: 'authoritative', display: 'Authoritative' },
];
const controlDQueryTargest = [
  { name: 'controldunfiltered', display: 'Unfiltered' },
  { name: 'controldmalware', display: 'Malware' },
  { name: 'controldadstracking', display: 'Ads & Tracking' },
  { name: 'controldsocial', display: 'Social' },
  { name: 'controldfamilyfriendly', display: 'Family Friendly' },
];
const localQueryTargets = {
  Africa: [
    { name: 'southafrica', display: 'South Africa' },
  ],
  Australia: [
    { name: 'australia', display: 'Australia' },
  ],
  Asia: [
    { name: 'india', display: 'India' },
    { name: 'russia', display: 'Russia' },
  ],
  Europe: [
    { name: 'thenetherlands', display: 'The Netherlands' },
    { name: 'ukraine', display: 'Ukraine' },
  ],
  'North America': [
    { name: 'canada', display: 'Canada' },
    { name: 'usa', display: 'United States of America' },
  ],
  'South America': [
    { name: 'brazil', display: 'Brazil' },
  ],
};

const otherRecordType = ref('SOA');
const otherRecordTypes = ['AFSDB', 'APL', 'CAA', 'CDNSKEY', 'CDS', 'CERT', 'CSYNC', 'DHCID', 'DLV', 'DNAME', 'DNSKEY', 'DS', 'HINFO', 'HIP', 'IPSECKEY', 'IXFR', 'KEY', 'KX', 'LOC', 'NAPTR', 'NSEC', 'NSEC3', 'NSEC3PARAM', 'OPENPGPKEY', 'OPT', 'PTR', 'RP', 'RRSIG', 'SIG', 'SMIMEA', 'SOA', 'SRV', 'SSHFP', 'TA', 'TKEY', 'TLSA', 'TSIG', 'URI', 'ZONEMD'];
const otherRecordTypeQuery = ref('SOA');
const filteredOtherRecordTypes = computed(() => (otherRecordTypeQuery.value === ''
  ? otherRecordTypes
  : otherRecordTypes.filter((item) => item.toLowerCase().includes(otherRecordTypeQuery.value.toLowerCase()))));

const domain = ref('');
const domainPunycode = ref('');
const dnsserver = ref(route.hash.substring(1));
const loadingOther = ref(true);
const loading = ref(true);
const error = ref<ApiErrorType | null>(null);
const showSidebar = ref(window.innerWidth > 991);
const cancelToken = ref<Canceler | null>(null);
const cancelTokenOtherRecords = ref<Canceler | null>(null);
const records = ref<PopularRecords>(emptyPopularRecords);
const otherRecords = ref<QueryResult>(emptyQueryResult);

function isCurrentTab(tab: string) {
  if (tab === 'local') {
    return Object.values(localQueryTargets).some((queryTargets) => queryTargets.some((target) => target.name === dnsserver.value));
  }
  if (tab === 'controld') {
    return Object.values(controlDQueryTargest).some((target) => target.name === dnsserver.value);
  }
  return tab === dnsserver.value;
}

function loadOtherRecord(): void {
  loadingOther.value = true;
  otherRecords.value = emptyQueryResult;

  // Cancel any previous request
  if (cancelTokenOtherRecords.value) {
    cancelTokenOtherRecords.value();
  }
  const axiosSource = axios.CancelToken.source();
  cancelTokenOtherRecords.value = axiosSource.cancel;

  axios.post('api/v1/other-records', {
    domain: domain.value,
    dnsServer: dnsserver.value,
    recordType: otherRecordType.value,
  }, {
    cancelToken: axiosSource.token,
  })
    .then((response) => {
      otherRecords.value = response.data.queryResult;
      loadingOther.value = false;
    })
    .catch((e) => {
      if (!axios.isCancel(e)) {
        console.log(e.message);
      }
    });
}

function load() {
  if (dnsserver.value === '') {
    dnsserver.value = 'cloudflare';
  }
  loading.value = true;
  error.value = null;
  records.value = emptyPopularRecords;

  if (cancelToken.value) {
    cancelToken.value();
  }
  const axiosSource = axios.CancelToken.source();
  cancelToken.value = axiosSource.cancel;

  axios.post<GetRecordsResponse>('api/v1/records', {
    domain: domain.value,
    dnsServer: dnsserver.value,
  }, {
    cancelToken: axiosSource.token,
  })
    .then((response) => {
      if (props.routerDomain !== domainNameToUrlPath(response.data.punycodeDomain)) {
        router.replace({
          path: `/domains/${domainNameToUrlPath(response.data.punycodeDomain)}/dns-records/`,
          hash: route.hash,
        });
      }
      domain.value = domainNameToDisplayName(response.data.unicodeDomain);
      domainPunycode.value = domainNameToDisplayName(response.data.punycodeDomain);
      records.value = response.data.records;
      if (otherRecordType.value === 'SOA') {
        loadingOther.value = false;
      }
      loading.value = false;
    })
    .catch((e) => {
      if (!axios.isCancel(e)) {
        error.value = toErrorType(e.response.data.error);
      }
    });

  if (otherRecordType.value === 'SOA') {
    loadingOther.value = true;
  } else {
    loadOtherRecord();
  }
}

function redirectTo(newDomain: string): void {
  router.push(`/domains/${domainNameToUrlPath(newDomain)}/dns-records/`);
}

watch(() => otherRecordType.value, () => loadOtherRecord());

watch(() => props.routerDomain, () => {
  const domainName = urlPathToDomainName(props.routerDomain);
  domain.value = domainName;
  domainPunycode.value = domainName;
  load();
}, {
  immediate: true,
});

watch(() => route.hash, () => {
  if (route.name !== 'Dns records') {
    return; // Prevent loading DNS records when moving to another page
  }

  dnsserver.value = route.hash.substring(1);
  load();
});

window.addEventListener('resize', () => {
  showSidebar.value = window.innerWidth > 991;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createVNode(MetaTags, {
        title: `DNS records for ${domain.value}`,
        description: `These are the uncached A, AAAA, CNAME, TXT, NS, MX and SOA records for ${domain.value}. Other DNS records are also available.`,
        url: `https://www.nslookup.io/domains/${domainPunycode.value}/dns-records/`
      }, null, 8, ["title", "description", "url"])
    ])),
    _createVNode(HeaderComponent, { domain: domain.value }, null, 8, ["domain"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("main", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, [
          _createTextVNode("DNS records for "),
          (domain.value === domainPunycode.value)
            ? (_openBlock(), _createElementBlock("b", _hoisted_4, _toDisplayString(domain.value), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _createElementVNode("b", null, _toDisplayString(domainPunycode.value), 1),
                _createTextVNode(" (" + _toDisplayString(domain.value) + ")", 1)
              ]))
        ]),
        (_unref(showUsersearchAd)())
          ? (_openBlock(), _createElementBlock("a", _hoisted_6, "Find domains by this owner"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("nav", _hoisted_8, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
              return _createVNode(_component_router_link, {
                key: tab.name,
                to: `#${tab.name}`,
                "aria-current": isCurrentTab(tab.name) ? 'page' : undefined,
                class: _normalizeClass([isCurrentTab(tab.name) ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-600 hover:text-gray-700 hover:border-gray-300',
                                ['google', 'opendns', 'authoritative'].includes(tab.name) ? 'hidden sm:inline' : '',
                                'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm'])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tab.display), 1)
                ]),
                _: 2
              }, 1032, ["to", "aria-current", "class"])
            }), 64)),
            _createVNode(_unref(Menu), {
              as: "div",
              class: "hidden sm:inline-block relative text-left"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_unref(MenuButton), {
                    class: _normalizeClass([
                isCurrentTab('controld') ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-600 hover:text-gray-700 hover:border-gray-300',
                'inline-flex w-full justify-center whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-transparent',
              ])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Control D "),
                      _createVNode(_unref(ChevronDownIcon), {
                        class: "-mr-1 ml-2 h-5 w-5",
                        "aria-hidden": "true"
                      })
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _createVNode(_Transition, {
                  "enter-active-class": "transition ease-out duration-100",
                  "enter-from-class": "transform opacity-0 scale-95",
                  "enter-to-class": "transform opacity-100 scale-100",
                  "leave-active-class": "transition ease-in duration-75",
                  "leave-from-class": "transform opacity-100 scale-100",
                  "leave-to-class": "transform opacity-0 scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(MenuItems), { class: "absolute -right-16 z-10 mt-2 w-44 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:right-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(controlDQueryTargest, (queryTarget) => {
                            return _createVNode(_component_router_link, {
                              key: queryTarget.name,
                              to: `#${queryTarget.name}`
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(MenuItem), null, {
                                  default: _withCtx(({ active }) => [
                                    _createElementVNode("span", {
                                      class: _normalizeClass([active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', isCurrentTab(queryTarget.name) ? '!text-indigo-600 font-medium' : '', 'block pl-6 pr-4 py-2 text-sm'])
                                    }, _toDisplayString(queryTarget.display), 3)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          }), 64)),
                          _createElementVNode("a", _hoisted_10, [
                            _createVNode(_unref(MenuItem), null, {
                              default: _withCtx(({ active }) => [
                                _createElementVNode("span", {
                                  class: _normalizeClass([active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'flex justify-between pl-6 pr-4 py-2 text-sm'])
                                }, [
                                  _createTextVNode(" Custom "),
                                  _createVNode(_unref(ArrowTopRightOnSquareIcon), { class: "w-4 float-right" })
                                ], 2)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(Menu), {
              as: "div",
              class: "relative inline-block text-left"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_unref(MenuButton), {
                    class: _normalizeClass([
                isCurrentTab('cloudflare') ? 'border-transparent text-gray-600 hover:text-gray-700 hover:border-gray-300' : 'border-indigo-500 text-indigo-600',
                !isCurrentTab('cloudflare') && !isCurrentTab('local') ? 'sm:border-transparent sm:text-gray-600 sm:hover:text-gray-700 sm:hover:border-gray-300' : '',
                'inline-flex w-full justify-center whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-transparent',
              ])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11,
                      _hoisted_12,
                      _createVNode(_unref(ChevronDownIcon), {
                        class: "-mr-1 ml-2 h-5 w-5",
                        "aria-hidden": "true"
                      })
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _createVNode(_Transition, {
                  "enter-active-class": "transition ease-out duration-100",
                  "enter-from-class": "transform opacity-0 scale-95",
                  "enter-to-class": "transform opacity-100 scale-100",
                  "leave-active-class": "transition ease-in duration-75",
                  "leave-from-class": "transform opacity-100 scale-100",
                  "leave-to-class": "transform opacity-0 scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(MenuItems), { class: "absolute -right-16 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:right-0" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.slice(1), (queryTarget) => {
                            return (_openBlock(), _createBlock(_component_router_link, {
                              key: queryTarget.name,
                              to: `#${queryTarget.name}`,
                              class: "block sm:hidden"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(MenuItem), null, {
                                  default: _withCtx(({ active }) => [
                                    _createElementVNode("span", {
                                      class: _normalizeClass([active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', isCurrentTab(queryTarget.name) ? '!text-indigo-600 font-medium' : '', 'block pl-6 pr-4 py-2 text-sm'])
                                    }, _toDisplayString(queryTarget.display), 3)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          }), 128)),
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(localQueryTargets, (queryTargets, name) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: name }, [
                              _createElementVNode("span", _hoisted_15, _toDisplayString(name), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(queryTargets, (queryTarget) => {
                                return (_openBlock(), _createBlock(_component_router_link, {
                                  key: queryTarget.name,
                                  to: `#${queryTarget.name}`
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(MenuItem), null, {
                                      default: _withCtx(({ active }) => [
                                        _createElementVNode("span", {
                                          class: _normalizeClass([active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', isCurrentTab(queryTarget.name) ? '!text-indigo-600 font-medium' : '', 'block pl-6 pr-4 py-2 text-sm'])
                                        }, _toDisplayString(queryTarget.display), 3)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              }), 128))
                            ], 64))
                          }), 64))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_unref(Menu), {
                as: "div",
                class: "ml-auto w-6 mr-4 flex"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(MenuButton), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Cog6ToothIcon), {
                        class: "h-6 w-6 text-gray-600",
                        "aria-hidden": "true"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_Transition, {
                    "enter-active-class": "transition ease-out duration-100",
                    "enter-from-class": "transform opacity-0 scale-95",
                    "enter-to-class": "transform opacity-100 scale-100",
                    "leave-active-class": "transition ease-in duration-75",
                    "leave-from-class": "transform opacity-100 scale-100",
                    "leave-to-class": "transform opacity-0 scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MenuItems), { class: "absolute right-12 top-3 z-10 p-3 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                        default: _withCtx(() => [
                          _createVNode(ToggleRawOutput, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Show raw data")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          (error.value !== null)
            ? (_openBlock(), _createBlock(ApiErrorAlert, {
                key: 0,
                error: error.value,
                domain: domain.value,
                dnsserver: dnsserver.value
              }, null, 8, ["error", "domain", "dnsserver"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_unref(dnsServers)[dnsserver.value].type === 'local')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, "A local DNS server in " + _toDisplayString(_unref(dnsServers)[dnsserver.value].pretty) + " responded with these DNS records. It will serve these records for as long as the time to live (TTL) has not expired. After this period, the DNS server will update its cache by querying one of the authoritative name servers.", 1))
                  : (_unref(dnsServers)[dnsserver.value].type === 'popular')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, "The " + _toDisplayString(_unref(dnsServers)[dnsserver.value].pretty) + " DNS server responded with these DNS records. " + _toDisplayString(_unref(dnsServers)[dnsserver.value].pretty) + " will serve these records for as long as the time to live (TTL) has not expired. After this period, " + _toDisplayString(_unref(dnsServers)[dnsserver.value].pretty) + " will update its cache by querying one of the authoritative name servers.", 1))
                    : (_unref(dnsServers)[dnsserver.value].type === 'control d')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("p", _hoisted_20, "The " + _toDisplayString(_unref(dnsServers)[dnsserver.value].pretty) + " DNS server responded with these DNS records. " + _toDisplayString(_unref(dnsServers)[dnsserver.value].pretty) + " will serve these records for as long as the time to live (TTL) has not expired. After this period, " + _toDisplayString(_unref(dnsServers)[dnsserver.value].pretty) + " will update its cache by querying one of the authoritative name servers.", 1),
                          _createElementVNode("p", _hoisted_21, [
                            (dnsserver.value == 'controldunfiltered')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_22, "This DNS server does not filter requests. "))
                              : (dnsserver.value == 'controldmalware')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, "This DNS server filters malware. "))
                                : (dnsserver.value == 'controldadstracking')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, "This DNS server filters ads and trackers. "))
                                  : (dnsserver.value == 'controldsocial')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, "This DNS server filters social media. "))
                                    : (dnsserver.value == 'controldfamilyfriendly')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, "This DNS server filters adult and drugs related sites. "))
                                      : (dnsserver.value == 'controlduncesored')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, "This DNS server restores access to censored sites. "))
                                        : _createCommentVNode("", true),
                            _hoisted_28
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock("p", _hoisted_29, "The authoritative DNS server responded with these DNS records. It has indicated that records should be cached for the period specified by the time to live (TTL). When the configuration of the authoritative DNS server changes, it will immediately serve the updated DNS records.")),
                _createElementVNode("div", _hoisted_30, [
                  (loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (n) => {
                          return _createElementVNode("div", { key: n }, [
                            _createVNode(SkeletonComponent, { class: "w-56 h-8 mb-6 mt-8" }),
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (n) => {
                              return _createElementVNode("div", { key: n }, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (n) => {
                                  return _createVNode(SkeletonComponent, {
                                    key: n,
                                    class: "inline-block w-1/2 h-4 pr-[10%] bg-clip-content"
                                  })
                                }), 64))
                              ])
                            }), 64))
                          ])
                        }), 64))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _hoisted_33,
                        _createVNode(IpDnsRecords, {
                          records: records.value.a,
                          "column-title": "IPv4 address",
                          "record-type": "A"
                        }, null, 8, ["records"]),
                        _hoisted_34,
                        _createVNode(IpDnsRecords, {
                          records: records.value.aaaa,
                          "column-title": "IPv6 address",
                          "record-type": "AAAA"
                        }, null, 8, ["records"]),
                        _hoisted_35,
                        _createVNode(DnsRecords, {
                          records: records.value.cname,
                          "column-title": "Canonical name",
                          "record-type": "CNAME",
                          "is-domain": true,
                          "can-have-multiple-records": false,
                          class: "w-full"
                        }, null, 8, ["records"])
                      ])),
                  (showSidebar.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createVNode(AdUnit, {
                          class: "!sticky top-16 mx-auto",
                          config: _unref(DnsRecordsSidebar)
                        }, null, 8, ["config"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (loading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                        return _createElementVNode("div", { key: n }, [
                          _createVNode(SkeletonComponent, { class: "w-56 h-8 mb-6 mt-8" }),
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                            return _createElementVNode("div", { key: n }, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                                return _createVNode(SkeletonComponent, {
                                  key: n,
                                  class: "inline-block w-1/3 h-4 pr-[10%] bg-clip-content"
                                })
                              }), 64))
                            ])
                          }), 64))
                        ])
                      }), 64))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _hoisted_39,
                      _createVNode(TxtRecords, {
                        records: records.value.txt,
                        domain: domain.value,
                        class: "w-full"
                      }, null, 8, ["records", "domain"]),
                      _createVNode(AdUnit, {
                        class: "mt-8 mx-auto",
                        config: _unref(DnsRecordsTxt)
                      }, null, 8, ["config"]),
                      _hoisted_40,
                      _createVNode(NsRecords, {
                        records: records.value.ns,
                        domain: domain.value,
                        class: "w-full"
                      }, null, 8, ["records", "domain"]),
                      _hoisted_41,
                      _createVNode(MxRecords, {
                        records: records.value.mx,
                        class: "w-full"
                      }, null, 8, ["records"])
                    ])),
                (loading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _createVNode(SkeletonComponent, { class: "w-56 h-8 mb-6 mt-8" })
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                      _hoisted_43,
                      _createVNode(_unref(Combobox), {
                        as: "div",
                        modelValue: otherRecordType.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((otherRecordType).value = $event)),
                        class: "mb-3 sm:mb-0 sm:mt-8 sm:ml-10 sm:inline-block"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ComboboxLabel), { class: "sr-only" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Additional record type")
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_44, [
                            _createVNode(_unref(ComboboxInput), {
                              onChange: _cache[0] || (_cache[0] = ($event: any) => (otherRecordTypeQuery.value = $event.target.value)),
                              onFocus: _cache[1] || (_cache[1] = ($event: any) => (otherRecordTypeQuery.value = '')),
                              class: "w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm"
                            }),
                            _createVNode(_unref(ComboboxButton), { class: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ChevronUpDownIcon), {
                                  class: "h-5 w-5 text-gray-400",
                                  "aria-hidden": "true"
                                })
                              ]),
                              _: 1
                            }),
                            (_unref(filteredOtherRecordTypes).length > 0)
                              ? (_openBlock(), _createBlock(_unref(ComboboxOptions), {
                                  key: 0,
                                  class: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredOtherRecordTypes), (person) => {
                                      return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                                        key: person,
                                        value: person,
                                        as: "template"
                                      }, {
                                        default: _withCtx(({ active, selected }) => [
                                          _createElementVNode("li", {
                                            class: _normalizeClass(['relative cursor-default select-none py-2 pl-3 pr-9', active ? 'bg-indigo-600 text-white' : 'text-gray-900'])
                                          }, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(['block truncate', selected && 'font-semibold'])
                                            }, _toDisplayString(person), 3),
                                            selected
                                              ? (_openBlock(), _createElementBlock("span", {
                                                  key: 0,
                                                  class: _normalizeClass(['absolute inset-y-0 right-0 flex items-center pr-4', active ? 'text-white' : 'text-indigo-600'])
                                                }, [
                                                  _createVNode(_unref(CheckIcon), {
                                                    class: "h-5 w-5",
                                                    "aria-hidden": "true"
                                                  })
                                                ], 2))
                                              : _createCommentVNode("", true)
                                          ], 2)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ], 64)),
                (loading.value || loadingOther.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                        return _createElementVNode("div", { key: n }, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                            return _createVNode(SkeletonComponent, {
                              key: n,
                              class: "inline-block w-1/3 h-4 pr-[10%] bg-clip-content"
                            })
                          }), 64))
                        ])
                      }), 64))
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                      (otherRecordType.value === 'SOA')
                        ? (_openBlock(), _createBlock(SoaRecords, {
                            key: 0,
                            records: records.value.soa,
                            domain: domain.value,
                            class: "w-full"
                          }, null, 8, ["records", "domain"]))
                        : (otherRecordType.value === 'CAA')
                          ? (_openBlock(), _createBlock(CaaRecords, {
                              key: 1,
                              records: otherRecords.value,
                              domain: domain.value,
                              class: "w-full"
                            }, null, 8, ["records", "domain"]))
                          : (otherRecordType.value === 'PTR')
                            ? (_openBlock(), _createBlock(PtrRecords, {
                                key: 2,
                                records: otherRecords.value,
                                domain: domain.value,
                                class: "w-full"
                              }, null, 8, ["records", "domain"]))
                            : (otherRecordType.value === 'SRV')
                              ? (_openBlock(), _createBlock(SrvRecords, {
                                  key: 3,
                                  records: otherRecords.value,
                                  domain: domain.value,
                                  class: "w-full"
                                }, null, 8, ["records", "domain"]))
                              : (otherRecordType.value === 'TLSA')
                                ? (_openBlock(), _createBlock(TlsaRecords, {
                                    key: 4,
                                    records: otherRecords.value,
                                    domain: domain.value,
                                    class: "w-full"
                                  }, null, 8, ["records", "domain"]))
                                : (_openBlock(), _createBlock(DnsRecords, {
                                    key: 5,
                                    records: otherRecords.value,
                                    "column-title": "Data",
                                    "record-type": otherRecordType.value,
                                    class: "w-full"
                                  }, null, 8, ["records", "record-type"]))
                    ], 64)),
                _createVNode(AdUnit, {
                  class: "mt-8 mx-auto",
                  config: _unref(DnsRecordsOther)
                }, null, 8, ["config"]),
                _hoisted_46,
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("p", _hoisted_48, [
                    _createTextVNode("With "),
                    _createVNode(_component_router_link, {
                      to: `/`,
                      class: "text-blue-600 hover:text-blue-800 hover:underline"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("DNS lookup")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(", you can find the DNS record for any domain name or subdomain. When you enter the domain, it will show all the DNS records that are configured for that domain.")
                  ]),
                  _createElementVNode("form", _hoisted_49, [
                    _createVNode(DomainSearch, {
                      emphasize: "",
                      prefill: domain.value,
                      onSubmitted: redirectTo
                    }, null, 8, ["prefill"])
                  ])
                ])
              ], 64))
        ])
      ])
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})